module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 12
// module chunks = 0 1 2 3